export const measurementLists = (measurementList, measurementType, isQuote) => {
  const measurementListsToApi = measurementList.map((each) => {
    // TODO: Removed `&& !each.itemLimitedQuantity` � LQ temporarily disabled (TruckMate not ready).
    if (each.itemDangerous && !isQuote) {
      return {
        measurementType: measurementType === 'Imperial' ? 1 : 0,
        weight: Number(each.itemWeight),
        length: Number(each.itemLength),
        width: Number(each.itemWidth),
        height: Number(each.itemHeight),
        pallets: each.SkidQty ? Number(each.SkidQty) : null,
        pieces: each.PieceQty ? Number(each.PieceQty) : null,
        commodityType: each.commodityType ? each.commodityType.code : '', // should be using this but not in the API spec
        description: each.description || '', // should be optional, remove fallback once api is fixed
        isDangerousGoods: each.itemDangerous,
        unNumber: each.unNumber,
        primaryClass: each.dgPrimaryClass || '',
        subClass: each.dgSubsidiaryClass || '',
        packagingGroup: each.dgPackagingGroup || null,
        packagingType: each.dgPackagingType === 'Other' ? '' : (each.dgPackagingType || ''),
        isToxicByInhalation: each.toxic ? each.toxic : false,
        quantity: each.totalQuantity,
        quantityType: each.totalQuantityUnits,
        shippingName: each.shippingName,
        numOfPackagesRequiringLabels: Number(each.numberPackRequireLabel),
        isNEQ: each.neq ? each.neq : false, // we don't capture this any more?
        freightClass: each.itemFreightClass, // we don't capture this any more?
        nmfc: each.itemNMFC || '', // should be optional, remove fallback once api is fixed
      };
    }

    // TODO: LQ branch temporarily disabled � not supported by backend (TruckMate) yet.
    // When LQ is re-enabled, this block sends empty DG detail fields for Limited Quantity items.
    // if (each.itemDangerous && each.itemLimitedQuantity && !isQuote) {
    //   return {
    //     measurementType: measurementType === 'Imperial' ? 1 : 0,
    //     weight: Number(each.itemWeight),
    //     length: Number(each.itemLength),
    //     width: Number(each.itemWidth),
    //     height: Number(each.itemHeight),
    //     pallets: each.SkidQty ? Number(each.SkidQty) : null,
    //     pieces: each.PieceQty ? Number(each.PieceQty) : null,
    //     commodityType: each.commodityType ? each.commodityType.code : '',
    //     description: each.description || '',
    //     isDangerousGoods: each.itemDangerous,
    //     primaryClass: each.primeClass || '',
    //     subsidaryClass: each.secondClass,
    //     packagingGroup: each.packagingGroup ? each.packagingGroup.value : null,
    //     isToxicByInhalation: each.toxic ? each.toxic : false,
    //     isNEQ: each.neq ? each.neq : false,
    //     freightClass: each.itemFreightClass,
    //     nmfc: each.itemNMFC || '',
    //     shippingName: '',
    //     unNumber: '',
    //     quantity: null,
    //     quantityType: null,
    //     numOfPackagesRequiringLabels: null,
    //   };
    // }

    return {
      measurementType: measurementType === 'Imperial' ? 1 : 0,
      weight: Number(each.itemWeight),
      length: Number(each.itemLength),
      width: Number(each.itemWidth),
      height: Number(each.itemHeight),
      pallets: each.SkidQty ? Number(each.SkidQty) : null,
      pieces: each.PieceQty ? Number(each.PieceQty) : null,
      commodityType: each.commodityType ? each.commodityType.code : '', // should be using this but not in the API spec
      description: each.description || '', // should be optional, remove fallback once api is fixed
      isDangerousGoods: each.itemDangerous,
      freightClass: each.itemFreightClass, // we don't capture this any more?
      nmfc: each.itemNMFC || '', // should be optional, remove fallback once api is fixed
      packagingGroup: '', // should be optional, remove fallback once api is fixed
      primaryClass: '', // we don't capture this any more?
      shippingName: '', // should be optional, remove fallback once api is fixed
      subsidaryClass: '', // should be optional, remove fallback once api is fixed
    };
  });

  return measurementListsToApi;
};

const ACCESSORIAL_SI_CODES = {
  APPTDL: '49',
  APPTPU: '48',
  CHAIN: '45',
  HAZMAT: '172',
  INSDDL: '31',
  INSDPU: '27',
  LTDAPU: '10',
  LTDADL: '32',
  PRESDL: '92',
  PRESPU: '93',
  PROTEC: '5',
  SITEDL: '70',
  SITEPU: '66',
  TLGDL: '41',
  TLGPU: '22',
  TRDSDL: '58',
  TRDSPU: '57',
  OVLGTH: '63',
};

export const accessorialsLists = (accessorials) => {
  if (!accessorials) {
    return null;
  }

  const selected = [];
  Object.keys(accessorials).forEach((accessorialKey) => {
    const keyname = accessorialKey.replace('acc', '');
    const isSelected = (accessorials[accessorialKey].selected === true);

    if (isSelected) {
      const isNumeric = /^\d+$/.test(keyname);
      const siCode = ACCESSORIAL_SI_CODES[keyname];
      const shippingInstructions = isNumeric || !!siCode;
      selected.push({
        accessorialId: isNumeric ? '' : keyname,
        code: isNumeric ? '' : keyname,
        value: Number(accessorials[accessorialKey].value) || undefined,
        shippingInstructions,
        shippingInstructionsCode: isNumeric ? keyname : (siCode || undefined),
        currencyCode: accessorials[accessorialKey].currency || undefined,
      });
    }
  });

  return selected;
};

export const getIsResidential = (residentialAddress, accessorials, accCode) => {
  let residentialStatus = residentialAddress;
  if (!residentialAddress) {
    residentialStatus = false;
    accessorialsLists(accessorials).map((item) => {
      if (item.code === accCode) {
        residentialStatus = true;
      }

      return undefined;
    });
  }

  return residentialStatus;
};
